import React from 'react';
import { IContactPersonLookup } from './interfaces';

export function formatContactPersonValue(contactPerson?: IContactPersonLookup) {
  if (!contactPerson) return '';
  if (Object.keys(contactPerson).length === 0) return '';

  const isUnknown = contactPerson.isPrivateContact === undefined;
  let status = '';
  if (!isUnknown) {
    if (contactPerson.isPrivateContact) {
      status = 'Privat';
    } else {
      status = 'Virksomhed';
    }
  }
  return `${contactPerson.name} ${status ? `(${status})` : ''}` || '';
}

function formatContactPersonOption(contactPerson?: IContactPersonLookup) {
  if (!contactPerson) return '';

  const isUnknown = contactPerson.isPrivateContact === undefined;
  let status = '';
  if (!isUnknown) {
    if (contactPerson.isPrivateContact) {
      status = 'Privat';
    } else {
      status = 'Virksomhed';
    }
  }

  let details = '';
  details += contactPerson.email ? contactPerson.email : '';
  details += contactPerson.email && contactPerson.title ? ', ' : '';
  details += contactPerson.title ? contactPerson.title : '';

  return (
    <div>
      <div>{`${contactPerson.name} ${status ? `(${status})` : ''}`}</div>
      <div>{details}</div>
      <div>{contactPerson.accountName}</div>
    </div>
  );
}

export function renderContactPerson(props: object, contactPerson?: IContactPersonLookup) {
  return (
    <li {...props} key={contactPerson?.id}>
      {formatContactPersonOption(contactPerson)}
    </li>
  );
}
